const getDataFromItems = (items, separator) => {
  separator = separator || ';';

  const replacer = (key, value) => {
    if (value === null) {
      value = '';
    }
    value = String(value).replace(separator, '\\' + separator);
    value = String(value).replace('"', '\"');

    return value;
  };

  const header = Object.keys(items[0]);

  let csv = items.map(row => {
    return header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(separator);
  });

  csv.unshift(header.join(separator));
  csv = csv.join('\r\n');

  return csv;
};

const serveCSV = (csv, filename) => {
  var downloadLink = document.createElement("a");
  var blob = new Blob(["\ufeff", csv]);
  var url = URL.createObjectURL(blob);

  downloadLink.href = url;
  downloadLink.download = filename;
  document.body.appendChild(downloadLink);
  downloadLink.click();
  document.body.removeChild(downloadLink);
};

const exportCSV = (filename, items, separator) => {
  const csv = getDataFromItems(items, separator);

  serveCSV(csv, filename);
};

const CSV = {
  getDataFromItems,
  serveCSV,
  export: exportCSV
};

export default CSV;


// WEBPACK FOOTER //
// ./src/utils/CSV.js